import { type ReactNode, useState, useEffect } from "react";
import { preload } from "react-dom";
import styles from "./Layout.module.scss";
import { Header } from "../Header"; 
import clsx from "clsx";
import { floor, floorDark } from "../../../assets/images";
import { PreloadedImage } from "../PreloadedImage";
import { HeaderVariant, type THeaderVariant } from "../Header/types";

interface LayoutProps {
  children: ReactNode;
  background?: string;
  showFooter?: boolean;
  customMainClass?: string;
  customPlaceholder?: string;
  darkMode?: boolean;
  headerVariant?: THeaderVariant;
}

const Layout = ({
  children,
  background,
  showFooter,
  customMainClass,
  customPlaceholder,
  darkMode,
  headerVariant = HeaderVariant.Brown30BlackWhiteLogo,
}: LayoutProps) => {
  const [isBgLoaded, setIsBgLoaded] = useState(false);

  useEffect(() => {
    if (background) {
      preload(background, { as: "image" });

      const img = new Image();
      img.src = background;
      img.onload = () => setIsBgLoaded(true);
    } else {
      setIsBgLoaded(true);
    }
  }, [background]);
  return (
    <div className={styles.bgWrapper}>
      <div
        className={clsx(styles.bgPlaceholder, customPlaceholder)}
        style={{ opacity: isBgLoaded ? 0 : 1, transition: "opacity 3s" }}
      />
      <div
        className={styles.bgImage}
        style={{
          backgroundImage: background ? `url(${background})` : undefined,
          opacity: isBgLoaded ? 1 : 0,
          transition: "opacity 3s",
        }}
      />
      <Header variant={headerVariant} />
      <main className={clsx(styles.main, customMainClass)}>{children}</main>
      {showFooter && (
        <footer className={styles.footer}>
          <PreloadedImage
            src={darkMode ? floorDark : floor}
            alt="Деревянный пол"
            className={styles.floorImg}
          />
        </footer>
      )}
    </div>
  );
};
export default Layout;